import { FormGroup } from "reactstrap";
import RSelect from 'react-select';
import Select from "../../../components/Select";
import { Label } from "reactstrap";
import { Input } from "reactstrap";
import { DISPLAY_COMPONENTS, DISPLAY_OPTIONS } from "./constants";
import { AppSettings, SelectOption } from "../../../globals/interfaces";
import _ from "lodash";
import useAppData from "../../../customHooks/useAppData";

const displayOptions = [];
Object.keys(DISPLAY_COMPONENTS).map(key => key !== 'multiDisplay' && displayOptions.push({ label: DISPLAY_COMPONENTS[key].name, value: key }));

export default function Settings({
    settings,
    setSettings,
    type
}: {
    settings: AppSettings;
    setSettings: React.Dispatch<React.SetStateAction<AppSettings>>;
    type?: 'kiosk' | null;
}) {

    const { stations } = useAppData();
    const unitOptions: Array<SelectOption> = (stations || []).map(item => ({ label: item.s_unit, value: item.s_unit }));

    const modifySettings = (key: keyof AppSettings, value: any) => {
        setSettings(prev => {
            const copy = _.cloneDeep(prev);
            // @ts-ignore
            copy[key] = value;
            return copy;
        });
    }

    const modifyMultiDisplaySelections = (options: Array<SelectOption>) => {
        modifySettings('multiDisplaySelection', options);
    }

    const { multiDisplaySelection } = settings;

    return (
        <div>
            <FormGroup>
                <Label>Name:</Label>
                <Input value={settings.name} onChange={(e) => modifySettings('name', e.target.value)} />
            </FormGroup>
            <Select
                label="Unit:"
                options={unitOptions}
                value={settings.unit ?? null}
                onChange={(opt) => modifySettings('unit', opt?.value ?? null)}
            />
            {
                type !== 'kiosk' && (
                    <Select
                        label='Display:'
                        options={DISPLAY_OPTIONS}
                        value={settings.display}
                        onChange={(opt) => modifySettings('display', opt?.value ?? null)}
                    />
                )
            }
            {
                settings.display === 'multiDisplay' && (
                    <div>
                        <FormGroup>
                            <Label>Select Displays:</Label>
                            <RSelect
                                isMulti
                                name="Displays"
                                value={multiDisplaySelection}
                                onChange={modifyMultiDisplaySelections}
                                options={displayOptions}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            // styles={customStyles}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Interval in minutes:</Label>
                            <Input 
                                type={'number'}
                                value={settings.multiDisplayInterval}
                                onChange={e => modifySettings('multiDisplayInterval', e.target.value)}
                            />
                        </FormGroup>
                    </div>
                )
            }
        </div>
    );
}